import { Accordion, AccordionMinimumHeight, ButtonColorEnum } from "norlys-ui-components";
import IStepInterface from "../../../../../Interfaces/IStepInterface";
import { useContext, useMemo, useState } from "react";
import PartnerContentContext from "../../../../../Contexts/PartnerContentContext";
import {
	Box,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material";

export const BetalingsserviceStep = ({
	nextStep,
	previousStep,
	order,
	open,
	toggleOpen,
	setOrder,
}: IStepInterface) => {
	const [regNumberError, setRegNumberError] = useState<boolean>(false);
	const [accountNumberError, setAccountNumberError] = useState<boolean>(false);
	const [subscribeToBs, setSubscribeToBs] = useState<boolean>(true);
	const partnerContentContext = useContext(PartnerContentContext);

	function handleRegNumberChange(input: string): any {
		if (subscribeToBs) {
			const regex = /^[0-9]{4}$/;
			setRegNumberError(!regex.test(input));
		}
		setOrder({ ...order, regNumber: input });
	}

	function handleAccountNumberChange(input: string): any {
		if (subscribeToBs) {
			const regex = /^[0-9]{1,10}$/;
			setAccountNumberError(input === "" || !regex.test(input));
		}
		setOrder({ ...order, accountNumber: input });
	}

	const formValid = useMemo(() => {
		if (subscribeToBs) {
			if (regNumberError || accountNumberError) {
				return false;
			}
			if (order.regNumber.length === 0 || order.accountNumber.length === 0) {
				return false;
			}
		}
		return true;
	}, [order.regNumber, order.accountNumber, accountNumberError, regNumberError, subscribeToBs]);

	return (
		<Accordion
			loading={false}
			loadingText={partnerContentContext.stepLoader.text}
			loadingTitle={partnerContentContext.stepLoader.title}
			label={partnerContentContext.salesInformationStep?.title || "Tilmeld Betalingsservice"}
			open={open}
			click={toggleOpen}
			firstButtonLabel={partnerContentContext.salesInformationStep?.backButton || "Tilbage"}
			firstButtonOutline={true}
			firstButton={previousStep}
			secondButtonLabel={partnerContentContext.salesInformationStep?.nextButton || "Næste"}
			secondButtonType={ButtonColorEnum.DARK_GREEN}
			secondButton={nextStep}
			secondButtonDisabled={!formValid}
			minimumHeight={AccordionMinimumHeight.SMALL}
			firstButtonId="bsSteoReturn"
			secondButtonId="bsStepForward"
			secondButtonShadow={true}>
			<Box display={"flex"} flexDirection={"column"} px={1.5}>
				<Typography mt={"10px"} mb={"15px"}>Bemærk venligst, at du skal angive en bankkonto, som ejes af personen med det tidligere oplyste CPR-nummer.</Typography>
				{!partnerContentContext.bsRequired && (
					<Box sx={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4 }}>
						<Box>Jeg vil gerne tilmelde mig Betalingsservice</Box>
						<FormControl component="fieldset" sx={{ marginRight: 2 }}>
							<RadioGroup
								row
								value={subscribeToBs ? "true" : "false"}
								onChange={(e) => setSubscribeToBs(e.target.value === "true")}>
								<FormControlLabel value="true" control={<Radio />} label="Ja" />
								<FormControlLabel value="false" control={<Radio />} label="Nej" />
							</RadioGroup>
						</FormControl>
					</Box>
				)}
				<Box display={"flex"} flex={1}>
					<Box flex={1}>
						<TextField
							error={regNumberError && subscribeToBs}
							variant="outlined"
							defaultValue={order.regNumber}
							placeholder="Reg. Nummer"
							onChange={(e) => handleRegNumberChange(e.target.value)}
							inputProps={{ maxLength: 4 }} //???
							sx={{ backgroundColor: "white" }}
							fullWidth={true}
							autoComplete="off"
						/>
						{regNumberError && subscribeToBs && (
							<Typography mt={1} sx={{ color: "red" }}>
								Ugyldigt reg. nummer
							</Typography>
						)}
					</Box>
					<Box flex={1} ml={"10px"}>
						<TextField
							error={accountNumberError && subscribeToBs}
							variant="outlined"
							defaultValue={order.accountNumber}
							placeholder="Kontonummer"
							onChange={(e) => handleAccountNumberChange(e.target.value)}
							inputProps={{ maxLength: 10 }} //???
							sx={{ backgroundColor: "white" }}
							fullWidth={true}
							autoComplete="off"
						/>
						{accountNumberError && subscribeToBs && (
							<Typography mt={1} sx={{ color: "red" }}>
								Ugyldigt kontonummer
							</Typography>
						)}
					</Box>
				</Box>
			</Box>
		</Accordion>
	);
};
